import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { CourseHourForm } from "./CourseHourForm";

export function DailyCourseHoursForm({
  handleChange,
  values
 }) {
  return (
    <>
      <Form.Group as={Row} controlId="semesterCount">
        <Form.Label column sm={2}>
          Dönem Sayısı
        </Form.Label>
        <Col sm={4}>
          <Form.Control type="number" min={0} max={4} value={values.semesterCount} placeholder="Dönem Sayısı" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="dailyCourseHour">
        <Form.Label column sm={2}>
          Günlük Ders Saati
        </Form.Label>
        <Col sm={4}>
          <Form.Control type="number" min={0} max={25} value={values.dailyCourseHour} placeholder="Günlük Ders Saati" onChange={handleChange} />
        </Col>
      </Form.Group>

      <div className="form-group row mt-10">
        <div className="col-1"></div>
        <div className="col-5">
          <h5 className="font-weight-bold text-dark text-center">
            Haftaiçi
          </h5>
        </div>
        <div className="col-5">
          <h5 className="font-weight-bold text-dark text-center">
            Haftasonu
          </h5>
        </div>
      </div>

      <div className="form-group row">
        <div className="col-2">
          <h5 className="font-weight-bold text-dark">
            Ders Saati
          </h5>
        </div>
        <div className="col-5">
          <div className="row">
            <div className="col-6">
              <h5 className="font-weight-bold text-dark">
                Başlangıç Saati
              </h5>
            </div>
            <div className="col-6">
              <h5 className="font-weight-bold text-dark">
                Bitiş Saati
              </h5>
            </div>
          </div>
        </div>
        <div className="col-5">
          <div className="row">
            <div className="col-6">
              <h5 className="font-weight-bold text-dark">
                Başlangıç Saati
              </h5>
            </div>
            <div className="col-6">
              <h5 className="font-weight-bold text-dark">
                Bitiş Saati
              </h5>
            </div>
          </div>
        </div>
      </div>

      { 
        values.dailyCourseHour > 0 &&
        [...Array(values.dailyCourseHour)].map((m, i) =>
          <CourseHourForm
            key={i}
            index={i}
            handleChange={handleChange}
            values={values.courseHours}
          />
        )
      }      
    </>
  );
}